import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Plug } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const INTEGRATIONS = [
  {
    id: 'stripe',
    name: 'Stripe',
    description: { fr: 'Paiements par carte', en: 'Card payments' },
    icon: 'S',
    bgColor: 'bg-[#635BFF]',
    status: 'connected'
  },
  {
    id: 'resend',
    name: 'Resend',
    description: { fr: 'Emails transactionnels', en: 'Transactional emails' },
    icon: 'R',
    bgColor: 'bg-black',
    status: 'connected'
  },
  {
    id: 'paypal',
    name: 'PayPal',
    description: { fr: 'Paiements PayPal', en: 'PayPal payments' },
    icon: 'Pay',
    bgColor: 'bg-[#003087]',
    status: 'coming'
  },
  {
    id: 'interac',
    name: 'Interac',
    description: { fr: 'Virement Interac e-Transfer', en: 'Interac e-Transfer' },
    icon: null,
    bgColor: 'bg-gradient-to-br from-[#FFBE00] to-[#FF8300]',
    status: 'coming',
    customIcon: true
  }
];

export default function AdminIntegrations() {
  const { language } = useLanguage();

  const getStatusBadge = (status) => {
    if (status === 'connected') {
      return (
        <span className="text-xs px-2 py-1 rounded-full bg-green-100 text-green-700">
          {language === 'fr' ? 'Connecté' : 'Connected'}
        </span>
      );
    }
    return (
      <span className="text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-500">
        {language === 'fr' ? 'Bientôt' : 'Coming Soon'}
      </span>
    );
  };

  const renderInteracIcon = () => (
    <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none">
      <circle cx="12" cy="12" r="10" fill="white"/>
      <path d="M7 12h10M12 7v10" stroke="#FF8300" strokeWidth="2.5" strokeLinecap="round"/>
    </svg>
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-blue-500 to-cyan-600 flex items-center justify-center shadow-lg">
            <Plug className="h-5 w-5 text-white" />
          </div>
          {language === 'fr' ? 'Intégrations' : 'Integrations'}
        </CardTitle>
        <CardDescription>
          {language === 'fr' ? 'Services externes connectés à PayHub' : 'External services connected to PayHub'}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {INTEGRATIONS.map((integration) => (
            <div 
              key={integration.id}
              className={`p-4 rounded-xl border ${integration.status === 'coming' ? 'border-dashed' : ''} border-border`}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className={`h-10 w-10 rounded-lg ${integration.bgColor} flex items-center justify-center ${integration.status === 'coming' ? '' : 'shadow-sm'}`}>
                    {integration.customIcon ? (
                      renderInteracIcon()
                    ) : (
                      <span className={`text-white font-bold ${integration.icon.length > 2 ? 'text-xs' : 'text-sm'}`}>
                        {integration.icon}
                      </span>
                    )}
                  </div>
                  <div>
                    <p className={`font-medium ${integration.status === 'coming' ? 'text-muted-foreground' : ''}`}>
                      {integration.name}
                    </p>
                    <p className="text-sm text-muted-foreground">
                      {integration.description[language] || integration.description.en}
                    </p>
                  </div>
                </div>
                {getStatusBadge(integration.status)}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
